import {
    BrindesResgatadosFornecedorActionsTypes,
    type BrindesResgatadosFornecedorActions,
} from "./brindesResgatadosFornecedorActions"
import {
    BrindesResgatadosFornecedorInicial,
    type BrindesResgatadosFornecedorModel,
} from "../models/brindesResgatadosFornecedorModel"

export { BrindesResgatadosFornecedorInicial }

export function brindesResgatadosFornecedorReducer(
    state: BrindesResgatadosFornecedorModel,
    action: BrindesResgatadosFornecedorActions
): BrindesResgatadosFornecedorModel {
    switch (action.type) {
        case BrindesResgatadosFornecedorActionsTypes.CARREGAR:
            return { ...state, brindes: action.payload }

        case BrindesResgatadosFornecedorActionsTypes.ATUALIZAR_FILTRO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        default:
            return state
    }
}
